import React from 'react';
import './SubTabs.css';

function SubTabs({ tabs, activeTab, setActiveTab }) {
  return (
    <div className="sub-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`sub-tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => setActiveTab(tab.id)}
        >
          <span className="sub-tab-label">{tab.label}</span>
          {tab.hasNotification && (
            <span className="sub-tab-notification-dot"></span>
          )}
        </button>
      ))}
    </div>
  );
}

export default SubTabs;








